import React from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";


const PaymentPopup = ({ data = {}, dropdownOptions = {} }) => {
  return (
    <div className="flex justify-center">
      <div className="grid gap-4 mb-2 md:grid-cols-2 w-full md:w-1/2 items-center">
        <DropDown
          name="paymentMethod"
          title="Payment Method"
          selectedOption={data.paymentMethod}
          options={dropdownOptions.paymentMethods || []}
          placeholder="Select Payment Method"
          disabled={true}
        />

        <InputText
          inputType="text"
          title="Amount Paid"
          name="amountPaid"
          content={data.amountPaid}
          disabled={true}
        />

        <InputText
          inputType="date"
          title="Payment date"
          name="Paymentdate"
          placeholder="Enter Date"
          disabled={false}
          // tabIndex="9"
          isRequired={true}
        />
        <DropDown
          name="paymentStatus"
          title="Payment Status"
          selectedOption={data.paymentStatus}
          options={dropdownOptions.paymentStatus || []}
          placeholder="Select Status"
          disabled={true}
        />

        <InputText
          inputType="text"
          title="Outstanding Amount"
          name="outstandingAmount"
          content={data.outstandingAmount}
          disabled={true}
        />

        <InputText
          inputType="text"
          title="Transaction Reference No."
          name="transactionRef"
          content={data.transactionRef}
          disabled={true}
        />

        <InputText
          inputType="text"
          title="Payment Confirmed"
          name="paymentConfirmed"
          content={data.paymentConfirmed ? "Yes" : "No"}
          disabled={true}
        />

        <InputText
          inputType="text"
          title="Refund (if any)"
          name="refundAmount"
          content={data.refundAmount}
          disabled={true}
        />
      </div>
    </div>
  );
};

export default PaymentPopup;